// extracted by mini-css-extract-plugin
export var active = "_1r-d";
export var blink = "_1r-e";
export var container = "_1r-5";
export var controls = "_1r-0";
export var controlsRight = "_1r-1";
export var fakeCursor = "_1r-c";
export var hidden = "_1r-b";
export var quillContainerSmall = "_1r-7";
export var quillEditor = "_1r-6";
export var quillEditorSmall = "_1r-8";
export var quillFormatButtons = "_1r-a";
export var quillToolbar = "_1r-9";
export var removePadding = "_1r-2";
export var state = "_1r-3";
export var stateTitle = "_1r-4";